<section class="dashboard">
  <div class="cui-action-bar">
    @for (capability of recentCapabilities(); track capability.key) {
      <a cuiButton variant="plain" [routerLink]="capability.routerLink">
        <span class="material-symbols-outlined">play_circle</span>
        Start "{{ capability.name }}"
      </a>
    } @empty {
      <button cuiButton disabled type="button" variant="plain">
        <span class="material-symbols-outlined">play_circle</span>
        Start Job
      </button>
    }
  </div>

  <app-job-run-history
    [paginationStore]="capabilityStore.allJobHistory"
    emptyMessage="No runs yet."></app-job-run-history>
</section>
